import { Component, OnInit } from '@angular/core';
import { Global } from "../global";
import { Components } from "../shared/components/components";
import { TranslateService } from '@ngx-translate/core';
import { Router } from "@angular/router";
import { Funcoes } from "../funcoes";
import { LoginService } from "../login/login.service";
import { LabelFotosLaudoscdService } from "../laudos-cd/label-fotos-laudoscd.service";
import { LabelFotosLaudoscdModel } from "../laudos-cd/label-fotos-laudoscd.model";

declare var swal: any;

@Component({
  selector: 'app-label-fotos-laudoscd',
  templateUrl: './label-fotos-laudoscd.component.html'
})
export class LabelFotosLaudoscdComponent extends Components implements OnInit {

  labelsFotos: LabelFotosLaudoscdModel[] = [];
  privilegioUsuario = {"editar": false, "consultar": false};

  constructor(
    public global: Global,
    protected translate: TranslateService,
    protected router: Router,
    public func: Funcoes,
    private loginService: LoginService,
    private labelFotosService: LabelFotosLaudoscdService
  ) {
    super();

    this.loginService.getUserInfo().subscribe(data => {
      for(let i in data.privilegios){
        if(data.privilegios[i].id_acao == '24'){
          this.privilegioUsuario.consultar = data.privilegios[i].consultar;
          this.privilegioUsuario.editar = data.privilegios[i].editar;
        }
      }
    });
  }

  ngOnInit() {
    this.carregandoTabela = true;
    this.getPage(1);
  }

  getPage(page: number) {
    this.paginaAtual = page;
    this.carregandoTabela = true;
    this.labelFotosService.getPaginacao(page, this.itensPorPagina, ['mercadorias']).subscribe(json => {
      this.labelsFotos = json.Payload.data;
      this.totalItens = json.Payload.total;
      this.carregandoTabela = false;
    }, error => {
      this.func.showErro(error.json());
      this.carregandoTabela = false;
    });
  }

  delete(labelFoto: LabelFotosLaudoscdModel) {
    let self = this;
    swal({
        title: this.func.traduzir('front.voceTemCerteza'),
        text: this.func.traduzir('front.desejaDeletarLabelFoto') + labelFoto.nome_pt + '?',
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: 'btn-danger',
        confirmButtonText: this.func.traduzir('front.confirmar'),
        cancelButtonText: this.func.traduzir('front.cancelar'),
        closeOnConfirm: true
      },
      function(){
        self.labelFotosService.apagar(labelFoto.id).subscribe(data => {
          self.getPage(self.paginaAtual);
        }, error => {
          self.func.showErro(error.json());
        });
      });
  }

  ordenouLabels(e) {
    for (let i = 0; i < this.labelsFotos.length; i++) {
      this.labelsFotos[i].ordem = (this.paginaAtual - 1) * parseInt(this.itensPorPagina) + i + 1;
    }
    this.labelFotosService.ordenaLabels(this.labelsFotos).subscribe(
      json => {
        // Success
      },
      error => {
        this.func.showErro(error.json());
      }
    );
  }

}




// WEBPACK FOOTER //
// ./src/app/label-fotos-laudoscd/label-fotos-laudoscd.component.ts